import { captureException } from '@sentry/nextjs';
import type { CaptureContext } from '@sentry/types';

export const parseSampleRate = (value: unknown, fallback: number): number => {
    const parsed = Number(value);
    if (!Number.isFinite(parsed)) {
        return fallback;
    }
    if (parsed < 0 || parsed > 1) {
        return fallback;
    }
    return parsed;
};

export const trackException = (exception: Error, context?: CaptureContext) =>
    captureException(exception, context);
